import { ReactNode } from 'react';
import { PageContainer } from '@/components/layout';

interface ProducerLayoutProps {
  children: ReactNode;
  /** Producer ID - kept for potential future use */
  farmId?: string;
  /** Producer name - kept for potential future use */
  producerName?: string;
  /** Page title - no longer used, kept for API compat */
  title?: string;
  /** Max width for content */
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

/**
 * Simplified ProducerLayout that only provides PageContainer.
 * AppShell is now rendered by UnifiedAppLayout - this component
 * exists for API compatibility with existing pages.
 */
export function ProducerLayout({ 
  children, 
  maxWidth = 'xl',
}: ProducerLayoutProps) {
  return (
    <PageContainer maxWidth={maxWidth}>
      {children}
    </PageContainer>
  );
}
